import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import UserIdleModal from './userIdleModal';

let logoutInterval = null;

const UserIdle = props => {
    const {activeCustomer, AutoLogout, handleLogout} = props;
    const [logoutState, setLogoutState] = useState({autoLogoutValue: AutoLogout * 60, limit: 30});

    useEffect(() => {
        if (!AutoLogout) {
            return;
        }
        if (AutoLogout) {
            setLogoutState({...logoutState, autoLogoutValue: AutoLogout * 60});
        }
        // eslint-disable-next-line
    }, [AutoLogout]);

    useEffect(() => {
        const clickListener = () => {
            setLogoutState({...logoutState, autoLogoutValue: AutoLogout * 60})
        }
        document.addEventListener('click', clickListener);

        if (logoutInterval) {
            clearInterval(logoutInterval);
        }

        if (!AutoLogout || !logoutState.autoLogoutValue) {
            return;
        }

        logoutInterval = setInterval(() => {
            let newValue = logoutState.autoLogoutValue - 1;

            if (newValue <= logoutState.limit) {
                setLogoutState({...logoutState, autoLogoutValue: newValue});
            }

            if (logoutState.autoLogoutValue <= 1) {
                setLogoutState({...logoutState, autoLogoutValue: newValue});
                handleLogout();
                return;
            }

            setLogoutState({...logoutState, autoLogoutValue: newValue});
        }, 1000);

        return () => {
            clearInterval(logoutInterval);
            document.removeEventListener('click', clickListener);
        }
        // eslint-disable-next-line
    }, [activeCustomer, AutoLogout, logoutState]);
    return (
            <UserIdleModal state={logoutState} open={logoutState?.autoLogoutValue < logoutState?.limit}
                           handleLogout={handleLogout}/>
    );
}

const mapStateToProps = state => {
    return {
        AutoLogout: state?.core?.login?.activeCustomer?.AutoLogout,
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID,
    };
};

export default connect(
    mapStateToProps,
    null
)(UserIdle);




